<div class="page-store-v1" *ngIf="isDataLoaded">
    <div class="store-breadcrumb">
        <div class="container"><a href="/">Home</a><span class="sep">&gt;</span><span class="current">{{ breadcrumTitle
                }}</span></div>
    </div>
    <section class="sh-section bg-white">
        <div class="container">
            <div class="sh-middle ptb-10">
                <h1>{{ breadcrumTitle }} Coupons &amp; Promo Codes {{ today | date:'yyyy' }}</h1>
                <p class="sh-subtitle" *ngIf="allItems.length > 0">Best {{ allItems.length }}
                    {{ breadcrumTitle | lowercase }} coupons and offers, verified {{ today | date:'MMMM dd yyyy' }}.
                </p>
            </div>
        </div>
    </section>
    <section class="store-content">
        <div class="container">
            <div class="store-grid">
                <aside class="store-sidebar-left">
                    <div class="sidebar-card">
                        <h3 class="sidebar-title">{{ breadcrumTitle }} Info</h3>
                        <ul class="coupons-info-list">
                            <li *ngIf="allItems.length > 0">
                                <span class="info-icon info-icon--blue">#</span>
                                <span>Total Offers:</span>
                                <strong>{{ allItems.length }}</strong>
                            </li>
                            <li *ngIf="coupons.length > 0">
                                <span class="info-icon info-icon--green">✓</span>
                                <span>Coupons:</span>
                                <strong>{{ coupons.length }}</strong>
                            </li>
                            <li *ngIf="offers.length > 0">
                                <span class="fresh-dot"></span>
                                <span>Deals:</span>
                                <strong>{{ offers.length }}</strong>
                            </li>
                        </ul>
                    </div>
                    <div class="sidebar-card trending-merchants-card" *ngIf="brands.length">
                        <h3 class="sidebar-title">Top Brands</h3>
                        <ul class="trending-list">
                            <li *ngFor="let brand of brands"><a [href]="'/' + brand.SeoName + '-coupons/'"><span
                                        class="merchant-name">{{ brand.StoreName }} Promo Codes</span><span
                                        class="coupon-count">{{ brand.CouponCount + brand.DealCount }}
                                        Coupons</span></a></li>
                        </ul>
                    </div>
                </aside>
                <main class="store-main">
                    <div class="deals-list">
                        <div class="nc-card" *ngFor="let coupon of allItems"
                            [hidden]="activeTab !== 'all' && (activeTab === 'coupons') !== (coupon.CouponCode != '')">
                            <div class="nc-top" onclick="ncMobileToggle(this)">
                                <div class="nc-badge">
                                    <span class="nc-lbl"
                                        *ngIf="itemBadge(coupon, 'OfferTitle') != ''">{{itemBadge(coupon,
                                        "OfferTitle")}}</span>
                                    <span class="nc-pct"
                                        *ngIf="itemBadge(coupon, 'CouponOfferTitle') != ''">{{itemBadge(coupon,
                                        'CouponOfferTitle')!.split(' ')[0]}}</span>
                                    <span class="nc-off"
                                        *ngIf="itemBadge(coupon, 'CouponOfferTitle') != ''">{{itemBadge(coupon,
                                        'CouponOfferTitle')!.split(' ')[1]}}</span>
                                </div>
                                <div class="nc-vdivider"></div>
                                <div class="nc-mid">
                                    <h3 class="nc-title">{{ itemTitle(coupon) | replaceMetaDate:today }}</h3>
                                    <button class="nc-toggle-btn" onclick="ncDesktopToggle(event, this)">
                                        Show Details
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="6 9 12 15 18 9" />
                                        </svg>
                                    </button>
                                    <div class="nc-meta-row">
                                        <button class="nc-toggle-pill" onclick="ncPillToggle(event, this)">
                                            Show Details
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <polyline points="6 9 12 15 18 9" />
                                            </svg>
                                        </button>
                                        <div class="nc-verified">
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                <polyline points="22 4 12 14.01 9 11.01" />
                                            </svg>
                                            Verified
                                        </div>
                                    </div>
                                </div>
                                <div class="nc-right">
                                    <div class="nc-verified">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                            <polyline points="22 4 12 14.01 9 11.01" />
                                        </svg>
                                        Verified
                                    </div>
                                    <button class="nc-deal-btn" onclick="ncRipple(event, this)"
                                        (click)="openItem(coupon)"> {{ itemHasCode(coupon) ? 'GET CODE' : 'GET DEAL'
                                        }}</button>
                                </div>
                                <div class="nc-mobile-arrow">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6" />
                                    </svg>
                                </div>
                            </div>
                            <div class="nc-expand">
                                <div class="nc-expand-inner">
                                    <ul class="nc-deal-list"
                                        [innerHTML]="itemDescription(coupon) | replaceMetaDate:today">
                                    </ul>
                                </div>
                                <div class="nc-coupon-wrap">
                                    <button class="nc-coupon-btn" onclick="ncRipple(event, this)"
                                        (click)="openItem(coupon)"> {{ itemHasCode(coupon) ? 'GET CODE' : 'GET DEAL'
                                        }}</button>
                                </div>
                            </div>
                            <div class="nc-footer">
                                <div class="nc-footer-left">
                                    <img [src]="itemStoreLogo(coupon)" class="tc-brand-img"
                                        [alt]="itemStoreName(coupon) + ' offers'" width="120" height="36" loading="lazy"
                                        decoding="async">
                                </div>
                                <a *ngIf="itemSeoName(coupon)" [href]="'/' + itemSeoName(coupon) + '-coupons/'"
                                    class="nc-brand-link">View All {{ itemStoreName(coupon) }} Offers</a>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    </section>
</div>